import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const ProtectedRoute = ({ requiredViewPermission, children }) => {
  const { permissions, loading, isAuthenticated } = useAuth()
  if (loading) return null
  if (!isAuthenticated) return <Navigate to="/" replace />
  if (!requiredViewPermission) return children
  if ((permissions?.[requiredViewPermission] || 'nao') !== 'sim') {
    return <Navigate to="/dashboard" replace />
  }
  return children
}

export default ProtectedRoute